// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterSimple_footer__Kj9ZC","inner":"FooterSimple_inner__iX3kO","links":"FooterSimple_links__lYdrl"};